/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { forwardRef } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import useScrollbarWidth from '@atlaskit/ds-lib/use-scrollbar-width';
import { useShouldNestedElementRender } from '../NestableNavigationContent/context';
import { containerCSS, innerContainerCSS, outerContainerCSS } from './styles';
/**
 * __Navigation content__
 *
 * A navigation content is used as the container for navigation items.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#content)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */
const NavigationContent = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    showTopScrollIndicator,
    children,
    testId
  } = props;
  const {
    shouldRender
  } = useShouldNestedElementRender();
  const scrollbar = useScrollbarWidth();
  if (!shouldRender) {
    return children;
  }
  const typedRef = ref;
  return jsx("div", {
    ref: typedRef
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    ,
    css: outerContainerCSS({
      showTopScrollIndicator,
      scrollbarWidth: scrollbar.width
    }),
    "data-testid": testId
  }, jsx("div", {
    ref: scrollbar.ref,
    css: innerContainerCSS({
      showTopScrollIndicator
    })
  }, jsx("div", {
    css: containerCSS({
      showTopScrollIndicator
    })
  }, children)));
});
export default NavigationContent;